module.exports = __webpack_public_path__ + "img/item-5.b4a9cf19.png";